// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3yDxM","label":"LabeledBox_label__3NK9t"};